import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ChangeUserPasswordContainer from './ChangeUserPassword/ChangeUserPasswordContainer';
import CreateUserContainer from './CreateUser/CreateUserContainer';
import UsersList from './UsersList';
import ChangeUserRoleContainer from './ChangeUserRole/ChangeUserRoleContainer';

const Routes = (): React.JSX.Element => (
  <Switch>
    <Route exact path="/users">
      <UsersList />
    </Route>
    <Route exact path="/users/create">
      <CreateUserContainer />
    </Route>
    <Route exact path="/users/change-password/:emailAddress">
      <ChangeUserPasswordContainer />
    </Route>
    <Route exact path="/users/change-role/:emailAddress/:role">
      <ChangeUserRoleContainer />
    </Route>
  </Switch>
);
export default Routes;
